import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useThemeStore } from './stores/theme'
import './style.css'

// Import custom components for markdown
import CollapsibleDirectory from './components/ui/CollapsibleDirectory.vue'
import DirectoryTree from './components/ui/DirectoryTree.vue'
import EnhancedMarkdownRenderer from './components/ui/EnhancedMarkdownRenderer.vue'

// Add a global error handler
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error)
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason)
})

try {
  const app = createApp(App)
  
  // Register global components for use in markdown
  app.component('CollapsibleDirectory', CollapsibleDirectory)
  app.component('DirectoryTree', DirectoryTree)
  app.component('EnhancedMarkdownRenderer', EnhancedMarkdownRenderer)
  
  const pinia = createPinia()
  app.use(pinia)
  app.use(router)

  // Initialize theme after app is created
  const themeStore = useThemeStore()
  themeStore.initializeTheme()

  const appElement = document.getElementById('app')
  if (!appElement) {
    throw new Error('App element #app not found in DOM')
  }
  
  // Add a loading indicator to the app element
  appElement.innerHTML = '<div style="padding: 20px; text-align: center; font-family: monospace;">Loading Vue app...</div>'
  
  app.mount('#app')
  
  // Clear the loading indicator after successful mount
  setTimeout(() => {
    if (appElement.innerHTML.includes('Loading Vue app...')) {
      appElement.innerHTML = ''
    }
  }, 1000)
  
} catch (error) {
  console.error('Error during Vue app initialization:', error)
  // Display error on page
  const appElement = document.getElementById('app')
  if (appElement) {
    appElement.innerHTML = `
      <div style="padding: 20px; color: red; font-family: monospace;">
        <h1>Vue App Failed to Load</h1>
        <p><strong>Error:</strong> ${error instanceof Error ? error.message : String(error)}</p>
        <p><strong>Stack:</strong></p>
        <pre style="background: #f5f5f5; padding: 10px; overflow: auto;">${error instanceof Error ? error.stack : 'No stack trace available'}</pre>
        <p><strong>Time:</strong> ${new Date().toISOString()}</p>
      </div>
    `
  }
}